import React from 'react';

import ReactImageMagnify from 'easy-magnify';

import { Image } from '../../domain/Image';
import { useResponsiveCloudinaryImage } from '../../libs/useResponsiveCloudinaryImage';

export interface ZoomedImageProps {
  src: string;
  srcSet: string;
  image: Image;
  zoomContainerId: string;
  alt: string;
}

export const ZoomedImage: React.FC<ZoomedImageProps> = (props) => {
  const { src: zoomSrc, srcSet: zoomSrcSet } = useResponsiveCloudinaryImage(props.image.zoom);

  return (
    <ReactImageMagnify
      {...{
        smallImage: {
          alt: props.alt,
          isFluidWidth: true,
          src: props.src,
          srcSet: props.srcSet,
          data: 'carouselImage',
        },
        largeImage: {
          srcSet: zoomSrcSet,
          src: zoomSrc,
          width: Image.ZoomSize,
          height: Image.ZoomSize,
        },
        enlargedImagePortalId: props.zoomContainerId,
        imageClassName: 'swan-adaptive-carousel-image',
        imageStyle: { objectFit: 'contain', aspectRatio: '1' },
      }}
    />
  );
};
